<script setup>
import {
  Activity,
  Airplay,
  AlertCircle,
  AlertTriangle,
  AlignCenter,
  AlignLeft,
  Archive,
  ArrowDown,
  ArrowDownCircle,
  ArrowLeft,
  ArrowLeftCircle,
  ArrowRight,
  ArrowUp,
  ArrowUpCircle,
  Bell,
  Bold,
  Box,
  Calendar,
  Check,
  CheckCircle,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsRight,
  Circle,
  Clipboard,
  Clock,
  Coffee,
  Copy,
  CornerUpLeft,
  CreditCard,
  Database,
  Disc,
  DollarSign,
  Download,
  Droplet,
  Edit,
  Edit2,
  Edit3,
  Eye,
  EyeOff,
  Facebook,
  Feather,
  File,
  FileCode,
  FileText,
  Filter,
  GitCommit,
  Github,
  Globe,
  Grid,
  Hash,
  Heart,
  HelpCircle,
  Home,
  Image,
  Info,
  Key,
  Layers,
  Layout,
  LifeBuoy,
  Link,
  List,
  Loader,
  Lock,
  LogIn,
  LogOut,
  Mail,
  Map,
  MapPin,
  Maximize,
  Menu,
  MessageCircle,
  MessageSquare,
  Minus,
  Monitor,
  Moon,
  MoreHorizontal,
  MoreVertical,
  Move,
  Package,
  Pause,
  PauseCircle,
  Phone,
  PieChart,
  Play,
  PlayCircle,
  Plus,
  PlusCircle,
  Printer,
  RefreshCw,
  RotateCcw,
  RotateCw,
  Search,
  Send,
  Server,
  Settings,
  Shield,
  ShoppingCart,
  Sidebar,
  Slash,
  Sliders,
  Square,
  Star,
  Sun,
  Tag,
  ToggleRight,
  Trash,
  Trash2,
  TrendingUp,
  Tv,
  Twitter,
  Type,
  Upload,
  User,
  UserPlus,
  UserX,
  Wrench,
  X,
  XCircle,
  XOctagon,
} from "lucide-vue-next"

defineOptions({ inheritAttrs: false })

const props = defineProps({
  icon: {
    required: true,
    type: [String, Object],
  },
  size: {
    type: String,
    default: "14",
  },
  badge: {
    type: [String, Object, Number],
    default: null,
  },
  badgeClasses: {
    type: [String, Object, Array],
    default: "badge-primary",
  },
})

const iconRegistry = {
  Activity,
  Airplay,
  AlertCircle,
  AlertTriangle,
  AlignCenter,
  AlignLeft,
  Archive,
  ArrowDown,
  ArrowDownCircle,
  ArrowLeft,
  ArrowLeftCircle,
  ArrowRight,
  ArrowUp,
  ArrowUpCircle,
  Bell,
  Bold,
  Box,
  Calendar,
  Check,
  CheckCircle,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsRight,
  Circle,
  Clipboard,
  Clock,
  Coffee,
  Copy,
  CornerUpLeft,
  CreditCard,
  Database,
  Disc,
  DollarSign,
  Download,
  Droplet,
  Edit,
  Edit2,
  Edit3,
  Eye,
  EyeOff,
  Facebook,
  Feather,
  File,
  FileCode,
  FileText,
  Filter,
  GitCommit,
  Github,
  Globe,
  Grid,
  Hash,
  Heart,
  HelpCircle,
  Home,
  Image,
  Info,
  Key,
  Layers,
  Layout,
  LifeBuoy,
  Link,
  List,
  Loader,
  Lock,
  LogIn,
  LogOut,
  Mail,
  Map,
  MapPin,
  Maximize,
  Menu,
  MessageCircle,
  MessageSquare,
  Minus,
  Monitor,
  Moon,
  MoreHorizontal,
  MoreVertical,
  Move,
  Package,
  Pause,
  PauseCircle,
  Phone,
  PieChart,
  Play,
  PlayCircle,
  Plus,
  PlusCircle,
  Printer,
  RefreshCw,
  RotateCcw,
  RotateCw,
  Search,
  Send,
  Server,
  Settings,
  Shield,
  ShoppingCart,
  Sidebar,
  Slash,
  Sliders,
  Square,
  Star,
  Sun,
  Tag,
  ToggleRight,
  Tool: Wrench,
  Trash,
  Trash2,
  TrendingUp,
  Tv,
  Twitter,
  Type,
  Upload,
  User,
  UserPlus,
  UserX,
  X,
  XCircle,
  XOctagon,
}

const iconComponent = computed(() => {
  const name = props.icon
  if (!name || typeof name !== "string")
    return Circle

  const baseName = name.endsWith("Icon") ? name.slice(0, -4) : name
  return iconRegistry[baseName] || Circle
})
</script>

<template>
  <span
    v-if="badge"
    class="feather-icon position-relative"
  >
    <component
      :is="iconComponent"
      :size="size"
      class="feather"
      v-bind="$attrs"
    />
    <span
      class="badge badge-up badge-pill"
      :class="badgeClasses"
    >{{ badge }}</span>
  </span>
  <component
    :is="iconComponent"
    v-else
    :size="size"
    class="feather"
    v-bind="$attrs"
  />
</template>

<style lang="scss">
svg.feather {
  outline: none;
}
</style>
